/**
 * SELECTOR custom fields answer ONE question about how they are picked:
 * one value, or many. It is a property of the FIELD (`CustomInput.valueTypes`),
 * never of where the field happens to be rendered.
 *
 * Before this existed the answer was decided by CONTEXT — a selector on the
 * lead rendered multi-select, the same selector on a deal rendered single —
 * so the same field behaved differently on two halves of one drawer. Every
 * renderer now asks here instead, which is what makes "Tag = multi everywhere,
 * Normal = single everywhere" true rather than aspirational.
 *
 * Stored values are the `PrefrenceValueTypes` enum: "normal" | "tags" | "img".
 * Anything that isn't "tags" is single-select — including the legacy "img" —
 * so an unset or unknown value degrades to the safer, narrower behaviour.
 */
export type CfSelectionMode = "normal" | "tags";

export function cfSelectionMode(field: {
  valueTypes?: string | null;
} | null | undefined): CfSelectionMode {
  return String(field?.valueTypes ?? "").trim().toLowerCase() === "tags"
    ? "tags"
    : "normal";
}

/** Multi-select? True only for Tag fields. */
export function isTagSelector(field: {
  valueTypes?: string | null;
} | null | undefined): boolean {
  return cfSelectionMode(field) === "tags";
}
